import React, { useEffect, useState } from 'react'
import { ReleaseZone, ReleaseZoneProperties } from 'models'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import * as modelProps from 'models/releaseZone/releaseZone-property-definitions';
import utils from 'features/releaseZone/releaseZone-util'
import validations from 'features/releaseZone/releaseZone-validation'

export interface ReleaseZoneProps {
    BuildList?: (
        page: any,
        name: ReleaseZoneProperties,
        form: ReleaseZone,
    ) => JSX.Element[]
    page?: any
    title?: any
    form?: ReleaseZone
    onUpdate?: (form: ReleaseZone, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function ReleaseZoneForm(props: ReleaseZoneProps) {
    let [form, setForm] = useState({} as ReleaseZone)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as ReleaseZone)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as ReleaseZone)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<ReleaseZone, ReleaseZoneProperties> | any = {
        ...utils,
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.ReleaseZoneProperties.Id,
                modelProps.ReleaseZoneProperties.Deleted,
                modelProps.ReleaseZoneProperties.Version,
                modelProps.ReleaseZoneProperties.Created,
                modelProps.ReleaseZoneProperties.Updated,
                modelProps.ReleaseZoneProperties.Owner,
            ].includes(x.name))
        },
        BuildList: (page, name: ReleaseZoneProperties, form: ReleaseZone) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        setForm: (
            form: ReleaseZone,
            property: ReleaseZoneProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: ReleaseZoneProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>
            {BuildForm<ReleaseZone, ReleaseZoneProperties>(args)}
        </React.Fragment>
    )
}
